import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {CreateInvoiceType} from '../types/TypesStore';
import {SelectedProductType} from './useProductsHandler';
import {useCreateInvoiceMutation} from '../redux/DepotSlice/depotOrdersApi';

export const useSubmitInvoice = () => {
	const navigate = useNavigate();
	const [createInvoice, { isLoading }] = useCreateInvoiceMutation();

	const submitInvoice = async (
		values: CreateInvoiceType,
		selectedProducts: SelectedProductType[],
	) => {
		const transformedProducts = selectedProducts.map((p) => ({
			product_id: Number(p.id),
			count: p.buyQuantity,
		}));
		const data: CreateInvoiceType = {
			type: values.type,
			contact_id: values.contact_id,
			ware_id: values.ware_id,
			address_id: values.address_id,
			country: values.country,
			points: values.points,
			money: values.money,
			order_id: values.order_id,
			products: transformedProducts,
			comment: values.comment,
		};

		try {
			const response = await createInvoice(data).unwrap();
			if (response.approve) {
				toast.success(response?.message?.textmsg);
				navigate('/list_of_invoices');
				return true;
			} else if (response.message && response.message.length > 0) {
				toast.error(
					response.message[0].textmsg || 'Error creating invoice',
				);
			} else {
				toast.error('Error creating invoice');
			}
		} catch (error) {
			console.error('Error submitting invoice:', error);
			toast.error('Error submitting invoice');
		}

		return false;
	};

	return {submitInvoice, isLoading};
};
